import React from 'react';
import { Link } from 'react-router-dom';

export default function ProductCard({ product }) {
  if (!product) return null;

  // Hent værdier (håndter lokalisering hvis nødvendigt)
  const title = product.title?.da || product.title || 'Uden titel';
  const descriptionHtml = product.description?.da || product.description || '';
  const price = product.price;
  const imageUrl = product.images?.[0] || 'https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/chokolenten-hero.jpg';

  // Optimer billedet med Cloudflare on-the-fly resizing (bredde 600px til kortet)
  const optimizedImageUrl = imageUrl.startsWith('https://assets.auxodev.dk')
    ? imageUrl.replace('https://assets.auxodev.dk/assets/', 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/')
    : imageUrl;

  return (
    <div className="group bg-cream-light rounded-2xl border border-choc-dark/10 overflow-hidden shadow-sm transition-all duration-300 hover:shadow-md hover:border-berry-accent/30 flex flex-col h-full">
      {/* Billede */}
      <div className="relative aspect-square overflow-hidden bg-choc-dark/5">
        <img
          src={optimizedImageUrl}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      </div>

      {/* Indhold */}
      <div className="p-6 flex flex-col flex-grow">
        {product.tag && (
          <div className="mb-2">
            <span className="text-xs font-sans font-bold uppercase tracking-wider text-berry-accent bg-berry-accent/10 px-2.5 py-1 rounded-full">
              {product.tag}
            </span>
          </div>
        )}
        <h3 className="text-xl font-serif font-bold text-choc-dark mb-2 group-hover:text-berry-accent transition-colors">
          {title}
        </h3>
        
        {descriptionHtml ? (
          <div 
            className="text-sm text-choc-dark/70 leading-relaxed font-sans prose prose-sm prose-chocolate"
            dangerouslySetInnerHTML={{ __html: descriptionHtml }}
          />
        ) : (
          <p className="text-sm text-choc-dark/50 italic font-sans">
            Ingen beskrivelse tilgængelig.
          </p>
        )}
      </div>
    </div>
  );
}
